module.exports = __webpack_public_path__ + "img/002.5568343e.jpg";